import { createSelector } from "@reduxjs/toolkit";

import { IStoreState } from "App/types";
import { IAuthActions } from "Auth/types";

export const currentUserSelector = (state: IStoreState) =>
  state.auth.currentUser;
export const authMetaSelector = (state: IStoreState, key: IAuthActions) =>
  state.auth.meta?.[key];

export const isUserAuthenticatedSelector = createSelector(
  currentUserSelector,
  (currentUser) => !!currentUser
);

export const userAttributesSelector = createSelector(
  currentUserSelector,
  (data) => data?.attributes
);
